// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__VSniq","rowMarginTop":"ResultsWrapper_rowMarginTop__Oh8qD","rowMarginBottom":"ResultsWrapper_rowMarginBottom__V1pb2"};